/** Exact image hosts observed in provider inventory and its image redirects. */
export const LISTING_PHOTO_HOSTS = ['img.rnudah.com', 'my1-cdn.pgimgs.com', 'sg1-cdn.pgimgs.com', 'my-rpfs.pgimgs.com', 'cdn.landsearch.com'] as const;
export const LISTING_IMAGE_ORIGINS = LISTING_PHOTO_HOSTS.map(host => `https://${host}`);

export function isTrustedListingPhotoUrl(value: unknown): value is string {
  if (typeof value !== 'string' || value.length > 2048 || !/^https:\/\//i.test(value) || /[\s\\\u0000-\u001f\u007f]/.test(value)) return false;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password && !url.port
      && LISTING_PHOTO_HOSTS.some(host => url.hostname === host);
  } catch {
    return false;
  }
}
